var global = window;

global.progressWidget = function(selector) {
    var delay = 0

    var $elements;
    if (!selector) {
        $elements = $('.progress');
    } else {
        var $root = $(selector);
        $elements = $root.filter('.progress').add($root.find('.progress'));
    }

    $elements.each(function (index) {
        $(this).removeClass('progress--full')
        // $(this).parent().removeClass('blanc');

        var current = $(this).data('progress')
        var max = $(this).data('max')
        var percent = 0
        var percentOriginal = 0
        var style = ''
        var styleParent = ''
        var styleAbs = ''
        if (max) {
            percent = (current / max) * 100
        }
        percentOriginal = percent
        if (percent < -100) {
            percent = -100
        }

        if (percent > 100) {
            percent = 100
        }

        if (percent < 0) {
            styleAbs = 'progress--red progress--reverse';
            percent = Math.abs(percent)
        }

        $(this).css('width', percent + '%')
        $(this).next().css('position', 'relative').css('z-index', '1')
        $(this).closest('.progress__wrap').next().css('position', 'relative').css('z-index', '1')
        $(this).parent().not('.progress__wrap').css('position', 'relative')
        $(this).closest('.progress__wrap').parent().css('position', 'relative')

        switch ($(this).data('target')) {
        case 'low':
            style = 'progress--green'
            if (percentOriginal > 100) {
                percent = 100
                style = 'progress--exceeding'
                styleParent = 'blanc'
            } else if (percent >= 80) {
                style = 'progress--red'
            } else if (percent >= 60) {
                style = 'progress--yellow'
            }
            break
        case 'high':
            style = 'progress--green'
            if (percent < 50) {
                style = 'progress--red'
            } else if (percent < 75) {
                style = 'progress--yellow'
            }
            break
        case 'max':
            style = 'progress--green'
            if (percent < 50) {
                style = 'progress--red'
            } else if (percent < 100) {
                style = 'progress--yellow'
            }
            break
        case 'inverted':
            if (percent < 30) {
                style = 'progress--red';
            } else if (percent < 50) {
                style = 'progress--yellow';
            }
            break
        case 'top':
            if (percentOriginal > 100) {
                style = 'progress--exceeding';
                styleParent = 'blanc';
            }
            break
        case 'negative':
            if (percentOriginal < 0) {
                style = 'progress--red';
            }
            else if (percentOriginal == 0) {
                style = 'progress--yellow';
            }
            break
        case '':
            break;
        default:
            style = 'progress--' + $(this).data('target');
            break;
        }

        if (percent >= 100) {
            style += ' progress--full'
        }

        $(this)
            .removeClass('progress--green')
            .removeClass('progress--yellow')
            .removeClass('progress--red')
            .removeClass('progress--full')
            .removeClass('progress--exceeding')
        if (style) $(this).addClass(style)
        if (!$(this).hasClass('progress--thin')) {
            if (styleParent) $(this).parent().addClass(styleParent)
        }
        if (styleAbs) $(this).addClass(styleAbs)

        // $(this).css('transition-duration', duration+'ms')
        $(this).css('transition-delay', delay + 'ms')
        delay += 10
    })
}

if (typeof BEHAV !== 'undefined' && BEHAV.add) {
    BEHAV.add(global.progressWidget);
}
